import * as React from 'react';

import type { NavigationStackEntry } from './context';
import Context from './context';

const NavigationStackProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [navigationStack, setNavigationStack] = React.useState<NavigationStackEntry[]>([]);
  return <Context.Provider value={{ navigationStack, setNavigationStack }}>{children}</Context.Provider>;
};

export default NavigationStackProvider;
